// extracted by mini-css-extract-plugin
module.exports = {"brandmark":"OAuthLink_brandmark__NAnmW","webexlink":"OAuthLink_webexlink__ZneTh"};